import React, { useState } from "react";
import { Plus, Trash2, Copy, Users, AlertCircle } from "lucide-react";
import { CollapsibleSection, FormField, KeyNameDialog } from "./AdminShared";

function POCManagementTab({ config, setConfig }) {
  const poc = config.function_poc || {};
  const [expandedKey, setExpandedKey] = useState(null);
  const [showKeyDialog, setShowKeyDialog] = useState(false);

  const pocTypes = [
    { key: "wfm_poc", label: "WFM POC", description: "Workforce Management" },
    { key: "slide_poc", label: "Slide POC", description: "Presentation Owner" },
    { key: "ops_poc", label: "Ops POC", description: "Operations Contact" },
  ];

  const updatePocLabel = (pocKey, value) => {
    setConfig((prev) => ({ ...prev, function_poc: { ...prev.function_poc, [pocKey]: { ...prev.function_poc[pocKey], label: value } } }));
  };

  const updatePoc = (pocKey, pocType, role, value) => {
    setConfig((prev) => ({ ...prev, function_poc: { ...prev.function_poc, [pocKey]: { ...prev.function_poc[pocKey], [pocType]: { ...prev.function_poc[pocKey]?.[pocType], [role]: value } } } }));
  };

  const handleAddPocKey = (keyName) => {
    setConfig((prev) => ({
      ...prev, function_poc: { ...prev.function_poc, [keyName]: {
        label: keyName.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
        wfm_poc: { primary: "", secondary: "" }, slide_poc: { primary: "", secondary: "" }, ops_poc: { primary: "", secondary: "" },
      }}
    }));
    setExpandedKey(keyName);
    setShowKeyDialog(false);
  };

  const removePocKey = (pocKey) => {
    if (!window.confirm(`Remove "${pocKey}"?`)) return;
    setConfig((prev) => { const updated = { ...prev.function_poc }; delete updated[pocKey]; return { ...prev, function_poc: updated }; });
    if (expandedKey === pocKey) setExpandedKey(null);
  };

  const duplicatePocKey = (pocKey) => {
    const newKey = `${pocKey}_copy`;
    setConfig((prev) => ({ ...prev, function_poc: { ...prev.function_poc, [newKey]: { ...JSON.parse(JSON.stringify(poc[pocKey])), label: `${poc[pocKey].label || pocKey} (Copy)` } } }));
    setExpandedKey(newKey);
  };

  const pocEntries = Object.entries(poc);

  return (
    <div className="admin-tab-content">
      <div className="admin-tab-content__toolbar">
        <span className="admin-toolbar-count">{pocEntries.length} entr{pocEntries.length === 1 ? "y" : "ies"}</span>
        <button className="admin-btn admin-btn--primary" onClick={() => setShowKeyDialog(true)}><Plus size={14} /> Add POC Entry</button>
      </div>
      <div className="admin-info-banner"><AlertCircle size={14} /><span>Each entry becomes a row in the Cover Page POC table.</span></div>
      {showKeyDialog && <KeyNameDialog existingKeys={Object.keys(poc)} onConfirm={handleAddPocKey} onCancel={() => setShowKeyDialog(false)} />}
      {pocEntries.map(([pocKey, pocEntry]) => (
        <CollapsibleSection key={pocKey} title={pocEntry?.label || pocKey} subtitle={`Key: ${pocKey}`} defaultOpen={expandedKey === pocKey}
          actions={<div className="admin-section__action-btns">
            <button className="admin-btn admin-btn--sm admin-btn--outline" onClick={() => duplicatePocKey(pocKey)}><Copy size={12} /></button>
            <button className="admin-btn admin-btn--sm admin-btn--danger" onClick={() => removePocKey(pocKey)}><Trash2 size={12} /></button>
          </div>}
        >
          <div className="admin-poc-label-field">
            <FormField label="Display Label" required hint="Appears in Cover Page POC table">
              <input className="admin-input" value={pocEntry.label || ""} onChange={(e) => updatePocLabel(pocKey, e.target.value)} />
            </FormField>
          </div>
          <div className="admin-poc-grid">
            {pocTypes.map(({ key: typeKey, label, description }) => (
              <div className="admin-poc-card" key={typeKey}>
                <div className="admin-poc-card__header"><h5 className="admin-poc-card__title">{label}</h5><p className="admin-poc-card__desc">{description}</p></div>
                <div className="admin-form-grid admin-form-grid--2">
                  <FormField label="Primary"><input className="admin-input" value={pocEntry[typeKey]?.primary || ""} onChange={(e) => updatePoc(pocKey, typeKey, "primary", e.target.value)} /></FormField>
                  <FormField label="Secondary"><input className="admin-input" value={pocEntry[typeKey]?.secondary || ""} onChange={(e) => updatePoc(pocKey, typeKey, "secondary", e.target.value)} /></FormField>
                </div>
              </div>
            ))}
          </div>
        </CollapsibleSection>
      ))}
      {pocEntries.length === 0 && (
        <div className="admin-empty-state"><Users size={40} /><h4>No POC entries</h4><button className="admin-btn admin-btn--primary" onClick={() => setShowKeyDialog(true)}><Plus size={14} /> Add First Entry</button></div>
      )}
    </div>
  );
}

export default POCManagementTab;
